// Recorded October 29 journal research targets; publication confirmed in
// outputs/journal-review-2026-10-29/PUBLICATION-STATUS.md and
// outputs/keyword-research-2026-10-29/drafts/14k-vs-18k-gold/publication-review.md.
// Collection and pendant-chain drafts are deliberately excluded.
export const optimizedTargets = [
  {
    "keyword": "how to clean diamond jewelry",
    "url": "https://lamorany.com/blogs/journal/how-to-care-for-diamond-jewelry",
    "newPage": false
  },
  {
    "keyword": "how to clean diamond jewelry at home",
    "url": "https://lamorany.com/blogs/journal/how-to-care-for-diamond-jewelry",
    "newPage": false
  },
  {
    "keyword": "how to clean diamond ring",
    "url": "https://lamorany.com/blogs/journal/how-to-care-for-diamond-jewelry",
    "newPage": false
  },
  {
    "keyword": "how to clean diamond earrings",
    "url": "https://lamorany.com/blogs/journal/how-to-care-for-diamond-jewelry",
    "newPage": false
  },
  {
    "keyword": "how to clean diamond earrings at home",
    "url": "https://lamorany.com/blogs/journal/how-to-care-for-diamond-jewelry",
    "newPage": false
  },
  {
    "keyword": "how to clean diamond necklace",
    "url": "https://lamorany.com/blogs/journal/how-to-care-for-diamond-jewelry",
    "newPage": false
  },
  {
    "keyword": "how to clean diamond and gold earrings",
    "url": "https://lamorany.com/blogs/journal/how-to-care-for-diamond-jewelry",
    "newPage": false
  },
  {
    "keyword": "how often to clean diamond ring",
    "url": "https://lamorany.com/blogs/journal/how-to-care-for-diamond-jewelry",
    "newPage": false
  },
  {
    "keyword": "how often should you clean diamond earrings",
    "url": "https://lamorany.com/blogs/journal/how-to-care-for-diamond-jewelry",
    "newPage": false
  },
  {
    "keyword": "how to clean diamonds at home",
    "url": "https://lamorany.com/blogs/journal/how-to-care-for-diamond-jewelry",
    "newPage": false
  },
  {
    "keyword": "ring size guide",
    "url": "https://lamorany.com/blogs/journal/ring-size-guide",
    "newPage": false
  },
  {
    "keyword": "measure ring size at home",
    "url": "https://lamorany.com/blogs/journal/ring-size-guide",
    "newPage": false
  },
  {
    "keyword": "measure ring size",
    "url": "https://lamorany.com/blogs/journal/ring-size-guide",
    "newPage": false
  },
  {
    "keyword": "us ring size chart",
    "url": "https://lamorany.com/blogs/journal/ring-size-guide",
    "newPage": false
  },
  {
    "keyword": "ring size chart in mm",
    "url": "https://lamorany.com/blogs/journal/ring-size-guide",
    "newPage": false
  },
  {
    "keyword": "ring size chart circumference",
    "url": "https://lamorany.com/blogs/journal/ring-size-guide",
    "newPage": false
  },
  {
    "keyword": "finger circumference to ring size",
    "url": "https://lamorany.com/blogs/journal/ring-size-guide",
    "newPage": false
  },
  {
    "keyword": "ring size with tape measure",
    "url": "https://lamorany.com/blogs/journal/ring-size-guide",
    "newPage": false
  },
  {
    "keyword": "measure ring size with string",
    "url": "https://lamorany.com/blogs/journal/ring-size-guide",
    "newPage": false
  },
  {
    "keyword": "ring size guide printable",
    "url": "https://lamorany.com/blogs/journal/ring-size-guide",
    "newPage": false
  },
  {
    "keyword": "ring size chart printable",
    "url": "https://lamorany.com/blogs/journal/ring-size-guide",
    "newPage": false
  },
  {
    "keyword": "ring size chart",
    "url": "https://lamorany.com/blogs/journal/ring-size-guide",
    "newPage": false
  },
  {
    "keyword": "lab grown diamonds vs natural",
    "url": "https://lamorany.com/blogs/journal/lab-grown-vs-natural-diamond-faq",
    "newPage": false
  },
  {
    "keyword": "lab vs natural diamond",
    "url": "https://lamorany.com/blogs/journal/lab-grown-vs-natural-diamond-faq",
    "newPage": false
  },
  {
    "keyword": "difference between lab grown and natural diamonds",
    "url": "https://lamorany.com/blogs/journal/lab-grown-vs-natural-diamond-faq",
    "newPage": false
  },
  {
    "keyword": "lab created diamonds vs natural",
    "url": "https://lamorany.com/blogs/journal/lab-grown-vs-natural-diamond-faq",
    "newPage": false
  },
  {
    "keyword": "natural vs lab grown diamonds",
    "url": "https://lamorany.com/blogs/journal/lab-grown-vs-natural-diamond-faq",
    "newPage": false
  },
  {
    "keyword": "lab grown vs natural diamond price",
    "url": "https://lamorany.com/blogs/journal/lab-grown-vs-natural-diamond-faq",
    "newPage": false
  },
  {
    "keyword": "lab grown diamonds vs real",
    "url": "https://lamorany.com/blogs/journal/lab-grown-vs-natural-diamond-faq",
    "newPage": false
  },
  {
    "keyword": "lab grown diamonds vs real diamonds price",
    "url": "https://lamorany.com/blogs/journal/lab-grown-vs-natural-diamond-faq",
    "newPage": false
  },
  {
    "keyword": "are lab grown diamonds real",
    "url": "https://lamorany.com/blogs/journal/are-lab-grown-diamonds-real",
    "newPage": false
  },
  {
    "keyword": "are lab diamonds real",
    "url": "https://lamorany.com/blogs/journal/are-lab-grown-diamonds-real",
    "newPage": false
  },
  {
    "keyword": "are lab created diamonds real",
    "url": "https://lamorany.com/blogs/journal/are-lab-grown-diamonds-real",
    "newPage": false
  },
  {
    "keyword": "is a lab grown diamond a real diamond",
    "url": "https://lamorany.com/blogs/journal/are-lab-grown-diamonds-real",
    "newPage": false
  },
  {
    "keyword": "are lab made diamonds real",
    "url": "https://lamorany.com/blogs/journal/are-lab-grown-diamonds-real",
    "newPage": false
  },
  {
    "keyword": "is a lab created diamond real",
    "url": "https://lamorany.com/blogs/journal/are-lab-grown-diamonds-real",
    "newPage": false
  },
  {
    "keyword": "14k vs 18k gold",
    "url": "https://lamorany.com/blogs/journal/14k-vs-18k-gold",
    "newPage": true
  }
];
export interface KeywordMetric {clicks:number;impressions:number;position:number}
export interface KeywordTracking {
 start:string;end:string;previousStart:string;previousEnd:string;days:number;
 rows:{keyword:string;url:string;newPage:boolean;before:KeywordMetric|null;after:KeywordMetric|null}[];
}
export function keywordStatus(r:KeywordTracking['rows'][number]){
 if(r.newPage)return r.after?'New page · now reported':'New page · not yet reported';
 if(!r.before&&!r.after)return 'No reported data';
 if(!r.before)return 'Newly reported';
 if(!r.after)return 'Not reported now';
 const gain=r.before.position-r.after.position;
 return gain>=0.5?'Gaining':gain<=-0.5?'Losing':'Little change';
}
